export const YOU_HAVE_NOT_AUTHORITY = "YouHaveNotAuthority"
export const PROTECT_REMOTE_DEVICE_KEY = "PROTECT_REMOTE_DEVICE_KEY"